import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FullViewportScroll } from '@sorare/core/src/atoms/container/FullViewportScroll';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconHeart } from '@sorare/core/src/atoms/icons/system/iconHeart.ts';
import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { SEARCH_PARAMS } from '@sorare/core/src/components/search/InstantSearch/types';
import { useGQLSearchContext } from '@sorare/core/src/contexts/graphql-search';
import { useScreenSize } from '@sorare/core/src/hooks/device/useScreenSize';
import { useLoggedCallback } from '@sorare/core/src/hooks/useLoggedCallback';
import { useEvents } from '@sorare/core/src/lib/events/useEvents';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';
import { glossary } from '@sorare/core/src/lib/glossary';

import { SegmentButton } from './ui.tsx';

const { favoriteFilter } = VIRTUAL_TOGGLE_FILTERS;

export const BackendSegment = () => {
  const { up: tabletOrAbove } = useScreenSize('tablet');
  const track = useEvents();
  const ctx = useGQLSearchContext()!;

  const favoritesActive = !!ctx.activeFacets.ff?.length;

  const setFavorites = (next: boolean) => {
    ctx.setSearchParams(params => {
      params.delete(SEARCH_PARAMS.PAGE);
      if (next) {
        params.set(favoriteFilter.name, 'true');
      } else {
        params.delete(favoriteFilter.name);
      }
      return params;
    });
    track('Use Market Filter', {
      filterName: favoriteFilter.trackingName,
      filterValue: next.toString(),
    });
  };

  const enableFavorites = useLoggedCallback<void>(() => setFavorites(true));

  return (
    <ConditionalWrapper wrap={!tabletOrAbove} Wrapper={FullViewportScroll}>
      <Horizontal>
        <SegmentButton
          className={classNames({ checked: !favoritesActive })}
          onClick={() => favoritesActive && setFavorites(false)}
        >
          <BodyM bold>
            <FormattedMessage {...glossary.all} />
          </BodyM>
        </SegmentButton>
        <SegmentButton
          className={classNames({ checked: favoritesActive })}
          onClick={() =>
            favoritesActive ? setFavorites(false) : enableFavorites()
          }
        >
          <BodyM bold>
            <FontAwesomeIcon icon={iconHeart} />{' '}
            <FormattedMessage {...favoriteFilter.label} />
          </BodyM>
        </SegmentButton>
      </Horizontal>
    </ConditionalWrapper>
  );
};
